<template>
  <div class="header">
    <div class="header-main">
      <el-row style="min-height: 100px;">
        <el-col :span="6" v-if="!$store.state.isPC">
          <div class="mobileMenu">
            <el-image v-if="isShowTopUl" style="width: 28px;" @click="isShowTopUl=false;"
                      :src="require('@/assets/img/menu.png')" fit="scale-down"></el-image>
            <!-- <i class="el-icon-s-unfold" v-if="isShowTopUl" style="font-size: 35px;" @click="isShowTopUl=false;"></i> -->
            <i class="el-icon-close" v-else style="font-size: 30px; color:#7B5C55;" @click="isShowTopUl=true;"></i>
          </div>
        </el-col>
        <!-- logo -->
        <el-col :span="$store.state.isPC?2:8" style="text-align: center;">
          <el-image
            class="logo hv"
            :src="require('@/assets/img/logo.png')"
            fit="contain"
            alt="Wenno"
            @click="isShowTopUl=true;$router.push('/Index');changeActTab('Index');">
          </el-image>
        </el-col>

        <!-- 导航栏 -->
        <el-col :offset="1" :span="13" v-if="$store.state.isPC">
          <div class="titleBar">
            <el-input v-model="searchVal" :placeholder="$t('top.contentTip')" @keydown.enter.native="toSearch()">
              <el-button slot="append" icon="el-icon-search" @click="toSearch()"></el-button>
            </el-input>
          </div>
        </el-col>

        <!-- 登录注册 -->
        <el-col :span="7" style="height: 100%">
          <div class="main-right fontPM">
            <!-- 货币 -->
            <div class="right-item hv" v-if="false && $store.state.isPC">
              <el-image
                :src="require('@/assets/img/cheap.png')"
                fit="contain">
              </el-image>
              <span>{{ $store.state.ccode }}</span>
            </div>
            <!-- 已登录 -->
            <div v-if="$store.state.token" class="right-item hv"
                 @click="isShowTopUl=true;$router.push('/AccountDetail');changeActTab('');">
              <el-image
                :src="require('@/assets/img/customer.png')"
                fit="contain">
              </el-image>
              <span v-if="$store.state.isPC">{{ $store.state.user.name }}</span>
            </div>
            <!-- 未登录 -->
            <div v-else class="right-item hv">
              <el-image
                :src="require('@/assets/img/customer.png')"
                fit="contain"
                @click="$store.commit('changeLoginShow',true);$store.commit('changeRegisterShow',false);">
              </el-image>
              <span v-if="$store.state.isPC"
                    @click="$store.commit('changeLoginShow',true);$store.commit('changeRegisterShow',false);">{{
                  $t('dialog.login')
                }}</span>
              <span v-if="$store.state.isPC">/</span>
              <span v-if="$store.state.isPC"
                    @click="$store.commit('changeLoginShow',false);$store.commit('changeRegisterShow',true);">{{
                  $t('dialog.signup')
                }}</span>
            </div>
            <!-- 购物车 -->
            <div class="right-item hv" @click="isShowTopUl=true;$store.commit('changeCartShow',true);">
              <el-badge :value="totalAmount==0?'':totalAmount" :max="10" class="item" type="warning"
                        style="line-height: 1;">
                <el-image
                  :src="require('@/assets/img/shopping_bag.png')"
                  fit="contain">
                </el-image>
              </el-badge>
              <span v-if="$store.state.isPC">{{ $t('dialog.cart') }}</span>
            </div>
            <!-- 选择语言 -->
            <div class="right-item hv">
              <!-- <el-image v-if="selectLangImg" :src="selectLangImg" class="langImg" fit="contain"></el-image> -->
              <el-dropdown trigger="click">
								<span class="el-dropdown-link">
									<el-image :src="require('@/assets/img/ic_language_48px.png')" fit="contain"></el-image>
                  <!--									<el-image v-if="selectLangImg" :src="selectLangImg" class="langImg" fit="contain"></el-image>-->
								</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in language"
                    @click.native="changeLang(item.title)"
                    :key="item.title">
                    <!-- <el-image
                        style="float: left;width:60px;height: 30px;"
                        :src="item.img"
                        fit="contain">
                      </el-image> -->
                    <span style="display: inline-block;color: #8492a6;font-size: 13px">{{ item.language }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-select v-model="lang" @change="changeLang($event)" > -->
              <!-- <template v-if="$store.state.actTab=='AnimalLibrary'">
                <el-option
                  v-for="item in language"
                  :key="item.title"
                  :label="item.language"
                  :value="item.title">
                  <el-image
                    style="float: left;width:60px;height: 30px;"
                      :src="item.img"
                      fit="contain">
                  </el-image>
                    <span style="display: inline-block;color: #8492a6;font-size: 13px">{{ item.language }}</span>
                </el-option>
              </template> -->
              <!-- <template v-else> -->
              <!-- v-if="item.title=='en'||item.title=='zh-TW'||item.title=='zh-CN'" -->
              <!-- <el-option
                v-for="item in language"
                :key="item.title"
                :label="item.language"
                :value="item.title">
                <el-image
                  style="float: left;width:60px;height: 30px;"
                    :src="item.img"
                    fit="contain">
                </el-image>
                  <span style="display: inline-block;color: #8492a6;font-size: 13px">{{ item.language }}</span>
              </el-option> -->
              <!-- </template> -->
              <!-- </el-select> -->
            </div>
            <div class="right-item hv" v-if="false && $store.state.isPC">
              <el-dropdown trigger="click">
								<span class="el-dropdown-link" style="font-size:16px">
									{{ $t('top.followUs') }}
								</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in followUs"
                    :key="item.name">
                    <!-- <el-image
                        style="float: left;width:60px;height: 30px;"
                        :src="item.img"
                        fit="contain">
                      </el-image> -->
                    <p class="followUs"><a :href="item.link" target="_blank">{{ item.name }}</a></p>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <div v-if="$store.state.isPC" class="right-item hv" @click="isShowTopUl=true;$router.push({path:'/ChooseRegion'});">
              <div v-if="$store.state.rcode=='hk'">中国香港</div>
              <div v-else-if="$store.state.rcode=='cn'">中国大陆</div>
              <div v-else-if="$store.state.rcode=='my'">马来西亚</div>
              <div v-else-if="$store.state.rcode=='us'">美国</div>
            </div> -->
          </div>
        </el-col>

      </el-row>

      <!-- 手机屏幕下的菜单 -->
      <ul class="menuInfo fontPB" v-if="!$store.state.isPC&&!isShowTopUl">
        <li class="hv">
          <el-input v-model="searchVal" :placeholder="$t('top.contentTip')">
            <el-button slot="append" icon="el-icon-search" @click="toSearch()"></el-button>
          </el-input>
        </li>
        <li v-if="false && isShowSale == 1" class="hv" @click="isShowTopUl=true;$router.push('/Sale')">
          {{ $t('top.sale') }}
        </li>
        <li class="hv" @click="$router.push('/Shop')">
          {{ $t('top.shop') }}
        </li>
        <li class="hv" @click="isShowTopUl=true;$router.push('/AnimalLibrary')">
          {{ $t('top.animal') }}
        </li>
        <li class="hv" @click="isShowTopUl=true;$router.push('/Collections')">
          {{ $t('top.collections') }}
        </li>

        <li v-if="false">
          <span @click="showToggle('shop')">
            {{ $t('top.shop') }}
            <i class="el-icon-arrow-down" :class="show.shop ? 'showRotate' : 'hideRotate'"></i></span>
          <ul style="font-size:18px" v-show="show.shop">
            <li>
              <span @click="showToggle('bucket')">
                {{ $t('top.animalsBucket') }}<i class="el-icon-arrow-down"
                                                :class="show.bucket ? 'showRotate' : 'hideRotate'"></i>
              </span>
              <ul style="font-size:14px" v-show="show.bucket">
                <li @click="isShowTopUl=true;toShop()">30 pcs</li>
                <li @click="isShowTopUl=true;toShop()">48 pcs</li>
                <li @click="isShowTopUl=true;toShop()">58 pcs</li>
              </ul>
            </li>
            <li @click="isShowTopUl=true;toShop(17)">{{ $t('top.animalsBox') }}</li>
            <li @click="isShowTopUl=true;toShop(24)">{{ $t('top.animalsPuzzle') }}</li>
            <li @click="isShowTopUl=true;toShop(43)">{{ $t('top.others') }}</li>
            <li @click="isShowTopUl=true;toShop(45)">{{ $t('top.sales') }}</li>
          </ul>
        </li>
        <li class="hv" @click="isShowTopUl=true;$router.push('/About')">
          {{ $t('top.about') }}
        </li>
        <li>
          <a href="/uploads/download/Wenno.apk" target="_blank">
            {{ $t('top.downloadApp') }}
          </a>
        </li>
        <li>
          <div class="hv">
            <el-image
              style="width: 18px; height: 18px;vertical-align: middle;"
              :src="require('@/assets/img/cheap.png')"
              fit="contain">
            </el-image>
            <span>{{ $store.state.ccode }}</span>
          </div>
        </li>
        <li class="hv">
					  <span @click="showToggle('followUs')">{{ $t('top.followUs') }}
						<i class="el-icon-arrow-down" :class="show.followUs ? 'showRotate' : 'hideRotate'"></i>
					  </span>
          <ul style="font-size:16px" v-show="show.followUs">
            <li v-for="item in followUs" :key="item.name">
              <a :href="item.link" target="_blank">{{ item.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- todo: top nav menu -->
    <div v-if="$store.state.isPC" style="background-color: #fde598; display: flex; justify-content: center">
      <el-menu :default-active="activeIndex"
               background-color="transparent"
               class="el-menu-demo tab fontPR" mode="horizontal">
        <el-menu-item index="2" @click="toSearch()">
          {{ $t('top.shop') }}
        </el-menu-item>
        <!--              <el-menu-item index="2" @click="toSearch($t('top.dinosaursKeyword'))">-->
        <!--                {{ $t('top.dinosaurs') }}-->
        <!--              </el-menu-item>-->
        <!--              <el-menu-item index="3" @click="toSearch($t('top.wildAnimalsKeyword'))">-->
        <!--                {{ $t('top.wildAnimals') }}-->
        <!--              </el-menu-item>-->
        <!--              <el-menu-item index="4" @click="toSearch($t('top.farmAnimalsKeyword'))">-->
        <!--                {{ $t('top.farmAnimals') }}-->
        <!--              </el-menu-item>-->
        <!--              <el-menu-item index="5" @click="toSearch($t('top.oceanAnimalsKeyword'))">-->
        <!--                {{ $t('top.oceanAnimals') }}-->
        <!--              </el-menu-item>-->
        <!--              <el-menu-item index="2" :class="$store.state.actTab=='2'?'active':''"-->
        <!--                            @click="$router.push('/Product');changeActTab('2')">{{ $t('top.product') }}-->
        <!--              </el-menu-item>-->
        <el-menu-item index="6" @click="$router.push('/AnimalLibrary')">
          {{ $t('top.animal') }}
        </el-menu-item>
        <!--              <el-menu-item index="5" :class="$store.state.actTab=='5'?'active':''"-->
        <!--                            @click="$router.push('/Blog');changeActTab('5')">{{ $t('top.blog') }}-->
        <!--              </el-menu-item>-->
        <el-menu-item index="7" @click="$router.push('/collections')">
          {{ $t('top.collections') }}
        </el-menu-item>
        <el-menu-item index="8" @click="$router.push('/About')">
          {{ $t('top.about') }}
        </el-menu-item>
        <el-menu-item index="9">
          <a href="/uploads/download/Wenno.apk" target="_blank">
            {{ $t('top.downloadApp') }}
          </a>
        </el-menu-item>
      </el-menu>
    </div>

  </div>
</template>
<script>
import en from '@/assets/imglang/en.png';
import zhTW from '@/assets/imglang/zh-TW.png';
import zhCN from '@/assets/imglang/zh-CN.png';

export default {
  data () {
    return {
      activeIndex: '0',
      searchVal: '',
      barList: [],
      isShowSale: 0,
      isShowTopUl: true,
      show: {
        shop: false,
        bucket: false,
        followUs: false,
      },
    };
  },
  mounted () {
    this.getUserInfo();
    this.isSale();
    if (this.$sessionStorage.actTab) {
      this.$store.commit('setActTab', this.$sessionStorage.actTab);
    }
    this.$store.commit('changeLanguage', this.$route.query.lang || this.$i18n.locale);
    if (this.$router.history.current.path.indexOf('/Animal') !== -1) {
      this.$store.commit('setActTab', 'AnimalLibrary');
    }
  },
  watch: {
    isShowTopUl () {
      if (!this.$store.state.isPC && !this.isShowTopUl) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  methods: {
    toShop (actId) {
      this.changeActTab('3');
      this.$router.replace({
        name: 'Shop',
        query: { actId },
      });
    },
    toSearch (v) {
      this.$router.push({
        name: 'Shop',
        query: {
          search: v || this.searchVal,
        },
      });
      this.isShowTopUl = true;
      this.searchVal = '';
      this.changeActTab('3');
    },
    showToggle (item) {
      console.log(item);
      this.show[item] = !this.show[item];
    },
    changeActTab (name) {
      this.$store.commit('setActTab', name);
    },
    changeLang (val) {
      this.$i18n.locale = val;
      this.$store.commit('setAnimal', '');
      this.$store.commit('setAnimalBg', 'Land');
      if (this.$store.state.actTab === 'AnimalLibrary') {
        let path = this.$router.history.current.path;
        this.$router.push(path);
        window.location.reload();
      } else {
        window.location.reload();
      }
      sessionStorage.setItem('language', val);
    },
    choonseLang (lang) {
      this.$axios({
        method: 'get',
        url: '/api/setLocale?lang=' + lang,
        headers: {
          'Authorization': this.$localStorage.token_type + this.$localStorage.token,
        },
      }).then(response => {
        console.log(response);
        window.location.reload();
      }).catch(error => {
        console.log(JSON.stringify(error));
      });
    },
    isSale () {
      this.$axios({
        method: 'GET',
        url: '/api/sales',
      }).then(res => {
        this.isShowSale = res.is_show;
      }).catch(error => {

      });
    },
    getUserInfo () {
      if (this.$localStorage.token) {
        this.$store.commit('setToken', this.$localStorage.token);
        this.$store.commit('setTokenType', this.$localStorage.token_type);
        this.$axios({
          method: 'get',
          url: '/api/user',
          headers: {
            'Authorization': this.$localStorage.token_type + this.$localStorage.token,
          },
        }).then(res => {
          console.log(res);
          this.$store.commit('setUserId', res.id);
          this.$store.commit('setUserName', res.name);
          this.$store.commit('setUserEmail', res.email);
          this.$store.commit('setNewsletter', res.is_newsletter);
          this.$store.commit('setLanguage', res.language);
        }).catch(error => {
          if (error.status_code == 401) {
            this.refreshToken();
          }
        });
      } else {
        return false;
      }
    },
    refreshToken () {
      this.$axios({
        method: 'PUT',
        url: '/api/authorizations/current',
        headers: {
          'Authorization': this.$localStorage.token_type + this.$localStorage.token,
        },
      }).then(res => {
        console.log(res);
        this.$localStorage.setItem('token', res.access_token);
        this.$store.commit('setToken', res.access_token);
        this.getUserInfo();
      }).catch(error => {
        this.$localStorage.clear();
        this.$store.commit('resetUser');
        this.$store.commit('resetCartList');
        this.$router.push('/Index');
        var self = this;
        setTimeout(function () {
          this.$store.state.isLoginShow = true;
        }, 1000);
      });
    },
  },
  computed: {
    totalAmount () {
      return this.$store.getters.totalAmount;
    },
    language () {
      return [
        {
          language: 'English',
          img: en,
          title: 'en',
        },
        {
          language: '中文繁體',
          img: zhTW,
          title: 'zh-TW',
        },
        {
          language: '中文简体',
          img: zhCN,
          title: 'zh-CN',
        },
      ];
    },
    followUs () {
      return [
        {
          name: 'FB',
          link: this.$t('socialMediaLinks.facebook'),
        }, {
          name: 'IG',
          link: this.$t('socialMediaLinks.instagram'),
        }, {
          name: 'WeChat',
          link: this.$t('socialMediaLinks.wechat'),
        },
      ];
    },
  },
};
</script>
<style scoped>
.followUs {
  width     : 100%;
  display   : inline-block;
  color     : #8492a6;
  font-size : 13px
}

.followUs a, li a {
  display         : block;
  text-decoration : none;
  color           : #7B5C55;
}

.showRotate {
  transform  : rotate(180deg);
  transition : all .5s;
}

.hideRotate {
  transform  : rotate(0deg);
  transition : all .5s;
}

ul, li {
  cursor : pointer;
}

.el-input-group {
  margin-right : auto;
}

.el-submenu__title:hover {
  background-color : rgb(3, 19, 33) !important;
}

.el-menu-item:hover {
  background-color : rgb(255, 200, 11) !important;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  color : #4B4B4B !important;
}

/deep/ .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  background-color : rgb(255, 200, 11) !important;
}

/deep/ .el-input--suffix .el-input__inner {
  background  : transparent;
  border      : none;
  width       : 110px;
  padding     : 0 0 0 30px;
  margin-left : -30px;
}

/deep/ .el-select {
  width   : 5px;
  opacity : 0;
}

/deep/ .el-input > .el-input__inner, input {
  /* width:5px; */
  /* opacity:0; */
  /* height:24px; */
  /* line-height:24px; */
}

/deep/ .el-select .el-input__inner:focus {
  background : transparent;
  border     : none;
}

/deep/ .el-icon-arrow-up:before, /deep/ .el-input__icon:after {
  content : '';
}

/deep/ .el-badge {
  z-index : 1;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-color : transparent;
}

.header {
  width            : 100%;
  background-color : #FFC80B;
  color            : #7B5D56;
}

.header-main {
  font-size  : 16px;
  min-height : 100px;
}

.mobileMenu {
  display     : inline-flex;
  height      : 30px;
  line-height : 30px;
  margin-top  : 35px;
  margin-left : 20px;
}

.logo {
  margin-top : 20px;
  width      : 86px;
  height     : 59px;
}

.titleBar {
  display         : flex;
  flex-direction  : column;
  justify-content : space-around;
  margin-top      : 30px;
}

.tab {
  display         : flex;
  justify-content : space-between;
  width           : 80%;
}

/deep/ .el-menu--horizontal > .el-menu-item {
  height      : 40px !important;
  line-height : 40px !important;
  color       : #7B5C55;
}

/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  font-weight : bold;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height      : 30px !important;
  line-height : 30px !important;
  padding     : 0;
}

.main-right {
  margin-left     : 10px;
  width           : 100%;
  height          : 24px;
  line-height     : 24px;
  color           : #7B5D56;
  font-size       : 16px;
  margin-top      : 38px;
  display         : flex;
  justify-content : flex-end;
}

.right-item {
  display      : flex;
  align-items  : center;
  margin-right : 30px;
}

.right-item > span {
  text-indent   : 5px;
  /* max-width:90px; */
  white-space   : nowrap;
  overflow      : hidden;
  text-overflow : ellipsis;
}

.right-item .el-image {
  width  : 20px;
  height : 20px;
}

.right-item .langImg {
  width  : 30px;
  height : 20px;
}

/deep/ .el-input__inner:hover, /deep/ .el-input__inner:focus {
  border-color : transparent !important;
}

/*手机*/
@media screen and (max-width : 768px) {
  .header {
    height : 80px;
  }

  .header-main {
    width  : 100%;
    height : 80px;
  }

  .mobileMenu {
    display     : inline-flex;
    height      : 30px;
    line-height : 30px;
    margin-top  : 25px;
    margin-left : 20px;
  }

  .logo {
    margin-top : 17px;
    width      : 64.5px;
    height     : 44.25px;
  }

  .main-right {
    width           : 100%;
    height          : 24px;
    line-height     : 24px;
    color           : #7B5D56;
    font-size       : 16px;
    margin-top      : 28px;
    display         : flex;
    justify-content : space-around;
  }

  .menuInfo {
    position         : fixed;
    height           : auto;
    width            : 100%;
    top              : 80px;
    left             : 0;
    width            : 100%;
    z-index          : 9999;
    text-align       : center;
    line-height      : 40px;
    background-color : #FFC80B;
    font-size        : 20px;
    color            : #7B5C55;
  }

  .active {
    border-bottom : none;
  }

  .right-item {
    position : relative;
  }

  .right-item span {
    position    : absolute;
    bottom      : -16px;
    text-indent : 0px;
    font-size   : 14px;
  }

  /deep/ .el-badge__content {
    font-size   : 10px;
    height      : 12px;
    line-height : 12px;
    padding     : 0 4px;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  .header-main {
    width  : 95%;
    margin : auto;
  }

  .header-main {
    font-size : 16px;
  }

  .mobileMenu {
    display     : inline-flex;
    height      : 30px;
    line-height : 30px;
    margin-top  : 35px;
    margin-left : 20px;
  }

  .logo {
    margin-top : 20px;
    width      : 86px;
    height     : 59px;
  }

  /* .tab{
    width: 100%;
    height: 26px;
    line-height: 26px;
    display: flex;
    justify-content: space-around;
    margin-top: 37px;
    color:#7B5C55;
  } */
  /* .tab>li{
    height: 26px;
    text-align: center;
    color: #4B4B4B;
  } */
  .active {
    border-bottom : 2px solid #4B4B4B;
  }

  .main-right {
    width           : 100%;
    height          : 24px;
    line-height     : 24px;
    color           : #7B5D56;
    font-size       : 16px;
    margin-top      : 38px;
    display         : flex;
    justify-content : space-around;
  }

  .right-item {
    margin-right : 0px;
  }

}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  .header-main {
    width  : 95%;
    margin : auto;
  }

  .right-item {
    margin-right : 5px;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {

  .header-main {
    width  : 90%;
    /* max-width: 1300px; */
    margin : auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Top.vue